import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

// Use environment variable or default to relative URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const REACT_APP_STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

console.log('API URL being used:', API_URL);

// Create API instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add auth token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors like 401 Unauthorized
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors (expired tokens, invalid tokens)
    if (error.response && error.response.status === 401) {
      console.log('Authentication error detected:', error.config.url);
      
      // Don't redirect for login failures - let the login page handle those errors
      if (error.config.url.includes('/auth/login')) {
        console.log('Login failed - not redirecting');
        return Promise.reject(error);
      }
      
      // For non-login 401 errors, assume token expiration
      console.log('Session expired. Logging out...');
      
      // Get current location including the hash/fragment
      const currentPath = window.location.pathname + window.location.search + window.location.hash;
      const encodedRedirect = encodeURIComponent(currentPath);
      
      // Clear auth data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect to login with session expired parameter and preserve the requested URL
      window.location.href = `/signin?session_expired=true&redirect=${encodedRedirect}`;
    }
    
    return Promise.reject(error);
  }
);

export default api; 